module.exports = __webpack_public_path__ + "img/bm.bm4f2a386.svg";